/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Render_Tts_TitleInputs */

const en_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Render virtual audio (text-to-speech)`)
};

const fr_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer un audio virtuel (synthese vocale)`)
};

const de_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtuelles Audio rendern (Text-zu-Sprache)`)
};

const it_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering audio virtuale (testo-voce)`)
};

const ru_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Воспроизведение виртуального звука (преобразование текста в речь)`)
};

const es_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderizar audio virtual (texto a voz)`)
};

const zh_cn2_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渲染虚拟音频（文本转语音）`)
};

const ja_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仮想オーディオ（テキスト読み上げ）をレンダリングする`)
};

const hi_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्चुअल ऑडियो (टेक्स्ट-टू-स्पीच) प्रस्तुत करें`)
};

const pt_pt2_event_ad_render_tts_title = /** @type {(inputs: Event_Ad_Render_Tts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderizar áudio virtual (conversão de texto em fala)`)
};

/**
* | output |
* | --- |
* | "Render virtual audio (text-to-speech)" |
*
* @param {Event_Ad_Render_Tts_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_render_tts_title = /** @type {((inputs?: Event_Ad_Render_Tts_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Render_Tts_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_render_tts_title(inputs)
	if (locale === "de") return de_event_ad_render_tts_title(inputs)
	if (locale === "it") return it_event_ad_render_tts_title(inputs)
	if (locale === "ru") return ru_event_ad_render_tts_title(inputs)
	if (locale === "es") return es_event_ad_render_tts_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_render_tts_title(inputs)
	if (locale === "ja") return ja_event_ad_render_tts_title(inputs)
	if (locale === "hi") return hi_event_ad_render_tts_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_render_tts_title(inputs)
	return en_event_ad_render_tts_title(inputs)
});